import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Card } from '../../components/ui/Card';
import './CountdownPage.css';

interface CountdownPageParams extends Record<string, string | undefined> {
  tableId: string;
  matchId: string;
  player1: string;
  player2: string;
}

export function CountdownPage() {
  const { tableId, matchId, player1, player2 } = useParams<CountdownPageParams>();
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    // Navigate to match page when countdown reaches 0
    if (countdown === 0) {
      navigate(`/match/${matchId}`);
      return;
    }

    // Countdown timer
    const timer = setTimeout(() => {
      setCountdown(countdown - 1);
      
      // Vibrate on last 3 seconds if supported
      if (countdown <= 3 && countdown > 0 && 'vibrate' in navigator) {
        navigator.vibrate(200);
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [countdown, matchId, navigate]);

  const handleCancel = () => {
    navigate(`/table/${tableId}/status`);
  };

  const getCountdownClass = () => {
    if (countdown <= 3) return 'countdown-page__timer--final';
    if (countdown <= 5) return 'countdown-page__timer--warning';
    return '';
  };

  return (
    <div className="countdown-page">
      <Card className="countdown-page__card">
        <div className="countdown-page__header">
          <h1 className="countdown-page__title">🏓 Partida Iniciando!</h1>
        </div>

        <div className="countdown-page__players">
          <div className="countdown-page__player">
            <div className="countdown-page__player-label">Jogador 1</div>
            <div className="countdown-page__player-name">{decodeURIComponent(player1 || '')}</div>
          </div>
          
          <div className="countdown-page__vs">VS</div>
          
          <div className="countdown-page__player">
            <div className="countdown-page__player-label">Jogador 2</div>
            <div className="countdown-page__player-name">{decodeURIComponent(player2 || '')}</div>
          </div>
        </div>

        <div className={`countdown-page__timer ${getCountdownClass()}`}>
          {countdown}
        </div>

        <p className="countdown-page__message">
          Prepare-se! A partida começará em breve.
        </p>

        <button 
          onClick={handleCancel}
          className="countdown-page__cancel-button"
        >
          Cancelar
        </button>
      </Card>
    </div>
  );
}
